import React from 'react';
import iconTC from '../../../../../../assets/icons/charts/overview/icon_topic_cloud_chart.svg';
import SVG from "react-inlinesvg";

const IconTemporalCloud = () => (
    <SVG src={iconTC}  height={40} style = {{ marginTop: 10}} />
);
export default IconTemporalCloud;